import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, signal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {MatCardModule} from '@angular/material/card';
import {FormGroup, FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { ProgressSpinnerModule } from '../../../../features/progress-spinner/progress-spinner-module';
import { PlayersService } from '../../../services/players/players';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { AllStatus } from '../../../../core/services/status/all-status';
import { Recover } from '../../recover/recover';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { InfoFullRoom } from '../../../dialogs/info-full-room/info-full-room';

@Component({
  selector: 'app-login-component',
  imports: [TranslatePipe,
    MatFormFieldModule, 
    MatInputModule, 
    MatButtonModule, 
    MatIconModule, 
    MatCardModule, 
    ReactiveFormsModule,
    ProgressSpinnerModule,
    Recover
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login-component.html',
  styleUrl: './login-component.scss'
})
export class LoginComponent implements OnInit {
  players = inject(PlayersService);
  allStatus = inject(AllStatus);
  readonly dialog = inject(MatDialog);
  translate = inject(TranslateService);

  isSignInClick: boolean = false;

  hide = signal(true);
  authService = inject(AuthService);
  configuration = inject(ConfigurationService);
  router = inject(Router);
  signIn = new FormGroup({
    user:  new FormControl('', [Validators.required]),
    password:  new FormControl('', [Validators.required]),
  });
  txtDialog: any;
  refid: any;
  subscriptionCL: import("rxjs").Subscription;

  constructor( private ref: ChangeDetectorRef){}
  
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
    event.preventDefault();
  }

  ngOnInit(){
    this.loadTranslateText();
    this.allStatus.resetRefreshNotValid();

    this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });

  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  public Login( $event: Event){
    $event.preventDefault();
    $event.stopPropagation();
    this.isSignInClick = true;
    let user = this.signIn.value.user as string;
    let password = this.signIn.value.password as string;
    //this.displayProgressSpinner = true;
    this.allStatus.textSpinner = this.txtDialog.txtSignIn;
    this.allStatus.setDisplayProgressSpinner(true);
    this.authService.getUserToken(user, password, '').subscribe({
      next: (e) =>{
        if(e.status === 302){
          this.configuration.setConfig().subscribe({
            next: () => this.completeLogin(),
            error: (error: any) => {
              this.isSignInClick = false;
              this.allStatus.setDisplayProgressSpinner(false);
              this.allStatus.textSpinner = '';
              this.ref.markForCheck();
              console.error(error);
            }
          });
        }
      },
      error:(error:any)=>{
        this.isSignInClick = false;
        this.allStatus.setDisplayProgressSpinner(false);
        this.allStatus.textSpinner = '';
        this.signIn.get('user')?.setErrors({ invalid: true });
        this.signIn.get('password')?.setErrors({ invalid: true });
        this.ref.markForCheck();
        console.error(error);
      }
    })
  }

  private completeLogin(): void {
    this.allStatus.setDownTime(false);
    this.ref.markForCheck();
    if (sessionStorage.getItem('shareStory') && sessionStorage.getItem('shareStory')?.length !== 0) {
      const data = {
        uuid: sessionStorage.getItem('shareStory')
      };

      this.players.getInfoRoom(data.uuid as string).subscribe((room: any) => {
        this.authService.isLoggedIn = true;
        if (room.room.number_of_players < room.room.maximum_players) {
          this.players.createPlayerInRoom(data).subscribe(() => {
            sessionStorage.removeItem('shareStory');
            this.router.navigate([`/waiting/${data.uuid}`]);
            this.isSignInClick = false;
          });
        } else {
          this.allStatus.fullRoom.set(true);
          this.allStatus.setDisplayProgressSpinner(false);
          this.router.navigate(['/step-one']);
          this.isSignInClick = false;
        }
      });
    } else {
      this.isSignInClick = false;
      this.authService.isLoggedIn = true;
      // this.allStatus.setDisplayProgressSpinner(false);
      // this.allStatus.textSpinner = '';
      //this.ref.markForCheck();
      this.router.navigate(['/step-one'], {queryParams: { refid: this.refid }});
    }
  }

  focusEvent(){
    if( this.signIn.get('user')?.value?.length as number > 3){
      this.signIn.get('user')?.setErrors(null);
    }

    if( this.signIn.get('password')?.value?.length as number > 3){
      this.signIn.get('password')?.setErrors(null);
    }
    // document.querySelector('.error-sign-in')?.classList.add('hide');
  }

}
